import ssfRest from '../np-rest/ssfRest';

const restDelete = props => {
    const [SSFRest] = ssfRest(props);
    return [SSFRest]
}

export default restDelete;